import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { PropsWithChildren, ReactNode } from 'react';
import { NextButton, PreviousButton } from '../../../presentation';

interface IProps extends PropsWithChildren {
  title: string;
  footer?: ReactNode;
  footerRight?: ReactNode;
  footerLeft?: ReactNode;
  headerRight?: ReactNode;
  onNext?: () => void;
  onPrevious?: () => void;
}

export const BrokerAgencyEntityPageContainer = ({
  title,
  footer,
  headerRight,
  footerLeft,
  footerRight,
  children,
  onNext,
  onPrevious,
}: IProps) => {
  return (
    <Stack flexGrow={1} overflow={'hidden'}>
      <Stack marginBottom={2} flexDirection={'row'}>
        <Stack>
          <Typography variant="h3" color="secondary">
            {title}
          </Typography>
        </Stack>
        <Stack flexGrow={1} />
        {headerRight && <Stack>{headerRight}</Stack>}
      </Stack>
      <Stack flexGrow={1} overflow={'auto'}>
        {children}
      </Stack>
      {(footer || footerLeft || footerRight || onNext || onPrevious) && (
        <Stack
          justifyContent={'space-between'}
          flexDirection={'row'}
          marginTop={2}
          alignItems={'center'}
        >
          {(footerLeft || footerRight || onNext || onPrevious) && (
            <Stack justifySelf={'flex-start'} flexDirection={'row'}>
              {footerLeft}
            </Stack>
          )}
          {footer && <Stack>{footer}</Stack>}
          {(footerRight || footerLeft || onNext || onNext || onPrevious) && (
            <Stack justifySelf={'flex-end'} flexDirection={'row'}>
              {footerRight}
              {onPrevious && <PreviousButton onClick={onPrevious} />}
              {onNext && <NextButton onClick={onNext} />}
            </Stack>
          )}
        </Stack>
      )}
    </Stack>
  );
};
